// extracted by mini-css-extract-plugin
export default {"list__wrapper":"_5D3qcX8_","list":"_5D13sOb2"};